import { ButtonType } from '@/common/components/base/button/Button.type.ts';
import { forwardRef, Ref } from 'react';
import { styled } from 'styled-system/jsx';
import button from '@/common/components/base/button/button.recipe.ts';

const Button = (props: ButtonType, ref: Ref<HTMLButtonElement> | undefined) => {
  const { variant, color, fullWidth, size, ...buttonProps } = props;
  const buttonVariants = button({
    variant,
    color,
    fullWidth,
    size,
  });
  return (
    <styled.button ref={ref} className={buttonVariants} {...buttonProps} />
  );
};
export default forwardRef(Button);
